export class PagedResult {
    Data: Array<any>;
    Total: number;
}
